/* eslint-disable react-hooks/exhaustive-deps */
import { Icons } from "../../../components/icons";
import { Card } from "../../../components/ui/card";

import { Formik } from "formik";
import { FilePlus2 } from "lucide-react";
import React from "react";
import Autocomplete from "react-google-autocomplete";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import FormError from "../../../components/FormError";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../components/ui/accordion";
import { Button } from "../../../components/ui/button";
import { Checkbox } from "../../../components/ui/checkbox";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { RadioGroup, RadioGroupItem } from "../../../components/ui/radio-group";
import fetchData from "../../../utils/api";
import { calculateDeliveryZoneDetails } from "../../../utils/calculate-delivery-zone-details";
import { Config } from "../../../utils/config";
import { isBase64 } from "../../../utils/is-base-64";
import { ssoDeleteAddressAPI } from "../../../utils/sso-apis";

export default function CartAccordionItem2({
  id,
  cartList,
  orderingMethod,
  setOrderingMethod,
  isLoading,
  setIsLoading,
  authToken,
  handleAccordionClick,
  handleCartList,
  restaurantDetail,
  isDineIn,
  selectedType,
  setSelectedType,
  ssoAddress,
  handleSSOAddress,
  ssoUserDetails,
}) {
  const [googleAddressPayload, setGoogleAddressPayload] = React.useState<any>(
    []
  );
  let selectedAddress =
    ssoAddress && ssoAddress.length > 0
      ? cartList?.orderingMethod?.sso_address
        ? ssoAddress.find(
            (i) => i.id === Number(cartList?.orderingMethod?.sso_address)
          )
        : ssoAddress[0]
      : null;

  const [isAddNewAddress, setAddNewAddress] = React.useState(false);
  const [isEditAddress, setEditAddress] = React.useState(false);

  const { t } = useTranslation();
  const pinCodeValidationMethod = ({ pinCode, zone }) => {
    const isPinCodeValid =
      restaurantDetail?.deliveryPostalCodes?.postal_codes.includes(pinCode);

    if (isPinCodeValid) {
      return isPinCodeValid;
    }

    if (!isPinCodeValid) {
      const applicableZone = calculateDeliveryZoneDetails(
        zone,
        restaurantDetail.deliveryPostalCodes?.zones ?? []
      );
      return applicableZone;
    }
    return false;
  };

  const handleSSODeleteAddress = async ({ addressId }) => {
    const ssoToken = localStorage.getItem("return_token");
    if (ssoToken && isBase64(ssoToken)) {
      const parsedCookie = atob(ssoToken);
      const deleteAddress = await ssoDeleteAddressAPI({
        addressId,
        token: parsedCookie,
      });
      if (deleteAddress) {
        handleSSOAddress({ token: parsedCookie });
      }
    }
  };

  const OrderingMethodFormValidation = Yup.object().shape({
    ordering_method: Yup.string().required(
      "cart.ordering_method.delivery.form.validation.ordering_method_required"
    ),
    sso_address: Yup.string().nullable(),
    // .test(
    //   "title_required",
    //   "cart.ordering_method.delivery.form.validation.sso_address_required",
    //   function (value) {
    //     const { ordering_method } = this.parent;
    //     if (ordering_method === "delivery") {
    //       return !!value;
    //     }
    //     return true;
    //   }
    // ),
    title: Yup.string().test(
      "title_required",
      "cart.ordering_method.delivery.form.validation.title_required",
      function (value) {
        const { ordering_method } = this.parent;
        if (ordering_method === "delivery") {
          return !!value;
        }
        return true;
      }
    ),
    google_address: Yup.string().test(
      "google_address_required",
      "cart.ordering_method.delivery.form.validation.google_address_required",
      function (value) {
        const { ordering_method } = this.parent;
        if (ordering_method === "delivery") {
          return !!value;
        }
        return true;
      }
    ),
    street_name: Yup.string().test(
      "street_name_required",
      "cart.ordering_method.delivery.form.validation.street_name_required",
      function (value) {
        const { ordering_method } = this.parent;
        if (ordering_method === "delivery") {
          return !!value;
        }
        return true;
      }
    ),
    area: Yup.string().test(
      "area_required",
      "cart.ordering_method.delivery.form.validation.area_required",
      function (value) {
        const { ordering_method } = this.parent;
        if (ordering_method === "delivery") {
          return !!value;
        }
        return true;
      }
    ),
    postal_code: Yup.string()
      .test(
        "postal_code_required",
        "cart.ordering_method.delivery.form.validation.postal_code_required",
        function (value) {
          const { ordering_method } = this.parent;
          if (ordering_method === "delivery") {
            return !!value;
          }
          return true;
        }
      )
      .test(
        "is-valid-pin",
        "cart.ordering_method.delivery.form.validation.postal_code_within_range",
        function (value) {
          const { ordering_method, location } = this.parent;
          if (ordering_method === "delivery") {
            // When adding a new address, we should use the location from form values
            // instead of trying to access selectedAddress which might be null
            if (isAddNewAddress || isEditAddress) {
              return (
                location &&
                pinCodeValidationMethod({
                  pinCode: value,
                  zone: location,
                })
              );
            } else if (
              selectedAddress &&
              selectedAddress.google_address &&
              selectedAddress.google_address[0] &&
              selectedAddress.google_address[0].location
            ) {
              return pinCodeValidationMethod({
                pinCode: value,
                zone: selectedAddress.google_address[0].location,
              });
            }
            // If we don't have location data yet, consider it valid temporarily
            // until location is selected
            return true;
          }
          return true;
        }
      ),
    location: Yup.object().test(
      "location_required",
      "cart.ordering_method.delivery.form.validation.location_required",
      function (value) {
        const { ordering_method } = this.parent;
        if (ordering_method === "delivery") {
          return !!value;
        }
        return true;
      }
    ),
    block_building: Yup.string().optional().nullable(),
    intercom: Yup.string().optional().nullable(),
    where_to_park: Yup.string().optional().nullable(),
  });
  return (
    <AccordionItem value="item-2" disabled={cartList?.contactDetails === null}>
      <AccordionTrigger>
        <div className="flex space-x-3">
          <div>
            <FilePlus2 />
          </div>
          <div>{t("cart.ordering_method.title")}</div>
        </div>
      </AccordionTrigger>
      <Formik
        enableReinitialize={true}
        initialValues={{
          ordering_method: isDineIn
            ? "dine_in"
            : cartList?.orderingMethod?.ordering_method ?? orderingMethod,
          title: selectedAddress?.title ?? "",
          google_address: selectedAddress?.google_address?.toString() ?? "",
          location:
            selectedAddress?.google_address?.length > 0
              ? selectedAddress?.google_address[0]?.location
              : {},
          street_name: selectedAddress?.street ?? "",
          area: selectedAddress?.city ?? "",
          postal_code: selectedAddress?.pincode ?? "",
          block_building: selectedAddress?.building ?? "",
          intercom: selectedAddress?.intercom ?? "",
          where_to_park: selectedAddress?.where_to_park ?? "",
          sso_address: cartList?.orderingMethod?.sso_address
            ? Number(cartList?.orderingMethod?.sso_address)
            : selectedAddress?.id ?? "",
        }}
        validationSchema={OrderingMethodFormValidation}
        onSubmit={async (values) => {
          setIsLoading(true);
          const cachedCart = localStorage.getItem("cart");
          try {
            const body: any = {
              cart_id: cachedCart,
              ordering_method: values.ordering_method,
              street_name: values.street_name,
              area: values.area,
              postal_code: values.postal_code,
              block_building: values.block_building,
              intercom: values.intercom,
              where_to_park: values.where_to_park,
              sso_address: values.sso_address,
              location: values.location,
              title: values.title,
            };
            if (isAddNewAddress) {
              try {
                const params = new URLSearchParams(window.location.search);
                const cookie: any = params.get("return_token");
                const parsedCookie = atob(cookie);
                const response = await fetch(
                  `${Config.env.app.sso_api_url}/profile/address/store`,
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Accept: "application/json",
                      Authorization: `Bearer ${parsedCookie}`,
                    },
                    body: JSON.stringify({
                      title: values.title,
                      street: values.street_name,
                      city: values.area,
                      pincode: values.postal_code,
                      building: values.block_building,
                      intercom: values.intercom,
                      where_to_park: values.where_to_park,
                      country_id: restaurantDetail.ssoCountryId,
                      state_id: restaurantDetail.ssoStateId,
                      phone: ssoUserDetails.mobile,
                      google_address: googleAddressPayload,
                    }),
                  }
                ).then((res) => res.json());
                if (response.status === true) {
                  handleSSOAddress({ token: parsedCookie });
                  body.sso_address = response.data.id;
                  values.sso_address = response.data.id;
                  setAddNewAddress(false);
                }
              } catch (error) {
                console.log("error", error);
              }
            }
            if (isEditAddress) {
              try {
                const params = new URLSearchParams(window.location.search);
                const cookie: any = params.get("return_token");
                const parsedCookie = atob(cookie);
                const response = await fetch(
                  `${Config.env.app.sso_api_url}/profile/address/${values.sso_address}/update`,
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Accept: "application/json",
                      Authorization: `Bearer ${parsedCookie}`,
                    },
                    body: JSON.stringify({
                      title: values.title,
                      street: values.street_name,
                      city: values.area,
                      pincode: values.postal_code,
                      building: values.block_building,
                      intercom: values.intercom,
                      where_to_park: values.where_to_park,
                      country_id: restaurantDetail.ssoCountryId,
                      state_id: restaurantDetail.ssoStateId,
                      phone: ssoUserDetails.mobile,
                      google_address: googleAddressPayload,
                    }),
                  }
                ).then((res) => res.json());
                if (response.status === true) {
                  handleSSOAddress({ token: parsedCookie });
                  setEditAddress(false);
                }
              } catch (error) {
                console.log("error", error);
              }
            }
            const res = await fetchData({
              url: "cart/ordering-method",
              method: "POST",
              body,
              token: authToken,
            });
            if (res.status_code === 200) {
              setOrderingMethod(values.ordering_method);
              setIsLoading(false);
              handleCartList();
              setSelectedType(values.ordering_method);
              handleAccordionClick("item-3");
            }
          } catch (error) {
            console.log("error", error);
          }
        }}
      >
        {({ errors, touched, setFieldValue, values, handleSubmit }) => {
          return (
            <form onSubmit={handleSubmit}>
              <AccordionContent className="space-y-2 p-2">
                <div className="grid gap-2 w-full">
                  {isDineIn ? (
                    <div className="flex items-center gap-2">
                      <Checkbox
                        disabled={isLoading}
                        id={"dine_in"}
                        checked={values.ordering_method === "dine_in"}
                        onCheckedChange={() => {
                          setFieldValue("ordering_method", "dine_in");
                        }}
                      />
                      <div className="flex justify-between w-full">
                        <div>
                          <label
                            htmlFor="cart.ordering_method.options.dine_in"
                            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 self-center"
                          >
                            {t("cart.ordering_method.options.dine_in")}
                          </label>
                        </div>
                      </div>
                    </div>
                  ) : (
                    Config.env.app.ordering_method.map((item, index) => {
                      if (
                        (item.value === "table_reservation" &&
                          !restaurantDetail.services.table_reservation) ||
                        (item.value === "pickup" &&
                          !restaurantDetail.services.pickup_service) ||
                        (item.value === "delivery" &&
                          !restaurantDetail.services.delivery_service) ||
                        (item.value === "in_restaurant" &&
                          (!restaurantDetail.services.table_reservation ||
                            !restaurantDetail.tableReservation
                              .allow_guest_pre_order)) ||
                        item.value === "dine_in"
                      ) {
                        // Skip the item if the condition is not matched
                        return null;
                      }
                      return (
                        <Card
                          id={item.label}
                          className="p-3 cursor-pointer"
                          key={index}
                        >
                          <div className="flex items-center gap-2">
                            <Checkbox
                              disabled={isLoading}
                              id={item.value}
                              checked={values.ordering_method === item.value}
                              onCheckedChange={() => {
                                setFieldValue("ordering_method", item.value);
                              }}
                            />
                            <div className="flex justify-between w-full">
                              <div>
                                <label
                                  htmlFor={item.value}
                                  className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 self-center"
                                >
                                  {t(item.label)}
                                </label>
                              </div>
                            </div>
                          </div>
                        </Card>
                      );
                    })
                  )}
                  {errors.ordering_method && touched.ordering_method ? (
                    <FormError msg={t(errors.ordering_method.toString())} />
                  ) : null}
                </div>
                {values.ordering_method === "delivery" &&
                  !isAddNewAddress &&
                  !isEditAddress && (
                    <div className="grid gap-2">
                      <div className="flex w-full justify-between">
                        {/* {ssoAddress && ssoAddress.length > 0 && (
                        <Button disabled variant={"link"}>
                          {t("cart.ordering_method.delivery.form.manage")}
                        </Button>
                      )} */}
                        <div className="flex w-full justify-end">
                          <Button
                            variant={"link"}
                            onClick={() => {
                              setAddNewAddress(true);
                              setFieldValue("title", "");
                              setFieldValue("street_name", "");
                              setFieldValue("area", "");
                              setFieldValue("postal_code", "");
                              setFieldValue("block_building", "");
                              setFieldValue("intercom", "");
                              setFieldValue("where_to_park", "");
                              setFieldValue("location", "");
                              setFieldValue("google_address", "");
                            }}
                          >
                            {t("cart.ordering_method.delivery.form.add_new")}
                          </Button>
                        </div>
                      </div>

                      <RadioGroup
                        className={`space-y-4  ${
                          ssoAddress && ssoAddress.length > 0
                            ? "max-h-[270px] h-fit"
                            : ""
                        }  overflow-y-auto no-scrollbar`}
                        value={values.sso_address}
                        onValueChange={(e: any) => {
                          setFieldValue("sso_address", e, true);
                          const newAddress = ssoAddress.find((i) => i.id === e);
                          selectedAddress = newAddress;
                          setFieldValue("title", newAddress.title);
                          setFieldValue("street_name", newAddress.street);
                          setFieldValue("area", newAddress.city);
                          setFieldValue("postal_code", newAddress.pincode);
                          setFieldValue("block_building", newAddress.building);
                          setFieldValue("intercom", newAddress.intercom);
                          setFieldValue(
                            "location",
                            newAddress?.google_address[0]?.location ?? ""
                          );
                          setFieldValue("google_address", newAddress.street);
                          setFieldValue(
                            "where_to_park",
                            newAddress.where_to_park
                          );
                        }}
                      >
                        {ssoAddress &&
                          ssoAddress.length > 0 &&
                          ssoAddress.map((item, index) => (
                            <Label htmlFor={item.id} key={index}>
                              <RadioGroupItem
                                value={item.id}
                                id={item.id}
                                className="peer sr-only"
                                aria-label={item.id}
                              />

                              <Label
                                htmlFor={item.id}
                                className="flex flex-col rounded-md border-2 border-muted bg-transparent p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary"
                              >
                                <div className="flex justify-between">
                                  <div>
                                    <div className="grid gap-2">
                                      <Label
                                        htmlFor={item.id}
                                        className="flex justify-start font-bold text-md"
                                      >
                                        {t(item.title)}
                                      </Label>
                                      <Label
                                        htmlFor={item.id}
                                      >{`${item.street}, ${item.city}, ${item.pincode}`}</Label>
                                    </div>
                                  </div>
                                  <div className="flex justify-center items-center">
                                    <Button
                                      type="button"
                                      variant={"link"}
                                      className="text-destructive"
                                      onClick={() => {
                                        handleSSODeleteAddress({
                                          addressId: item.id,
                                        });
                                      }}
                                    >
                                      {t(
                                        "cart.ordering_method.delivery.form.delete"
                                      )}
                                    </Button>
                                  </div>
                                  <div className="flex justify-center items-center">
                                    <Button
                                      type="button"
                                      variant={"link"}
                                      onClick={() => {
                                        setEditAddress(true);
                                        setFieldValue(
                                          "sso_address",
                                          item.id,
                                          true
                                        );
                                        const newAddress = ssoAddress.find(
                                          (i) => i.id === item.id
                                        );
                                        selectedAddress = newAddress;
                                        setFieldValue(
                                          "title",
                                          newAddress.title
                                        );
                                        setFieldValue(
                                          "street_name",
                                          newAddress.street
                                        );
                                        setFieldValue("area", newAddress.city);
                                        setFieldValue(
                                          "postal_code",
                                          newAddress.pincode
                                        );
                                        setFieldValue(
                                          "block_building",
                                          newAddress.building
                                        );
                                        setFieldValue(
                                          "intercom",
                                          newAddress.intercom
                                        );
                                        setFieldValue(
                                          "location",
                                          newAddress?.google_address[0]
                                            ?.location ?? ""
                                        );
                                        setFieldValue(
                                          "google_address",
                                          newAddress.street
                                        );
                                        setFieldValue(
                                          "where_to_park",
                                          newAddress.where_to_park
                                        );
                                        setGoogleAddressPayload(
                                          newAddress.google_address
                                        );
                                      }}
                                    >
                                      {t(
                                        "cart.ordering_method.delivery.form.edit"
                                      )}
                                    </Button>
                                  </div>
                                </div>
                              </Label>
                            </Label>
                          ))}
                      </RadioGroup>
                      {errors.postal_code && touched.postal_code ? (
                        <FormError msg={t(errors.postal_code as string)} />
                      ) : null}
                      {errors.location && touched.location ? (
                        <FormError msg={t(errors.location as string)} />
                      ) : null}
                    </div>
                  )}
                {values.ordering_method === "delivery" &&
                  (isAddNewAddress || isEditAddress) && (
                    <div className="grid gap-2">
                      <div className="grid gap-2 w-full">
                        <Label className="text-left" htmlFor="title">
                          {t("cart.ordering_method.delivery.form.title")}
                        </Label>
                        <div>
                          <Input
                            id="title"
                            placeholder={t(
                              "cart.ordering_method.delivery.form.title_placeholder"
                            )}
                            value={values.title}
                            onChange={(e: any) => {
                              setFieldValue("title", e.target.value, true);
                            }}
                            disabled={isLoading}
                          />
                          {errors.title && touched.title ? (
                            <FormError msg={t(errors.title as string)} />
                          ) : null}
                        </div>
                      </div>
                      <div className="grid gap-2 w-full">
                        <Label className="text-left" htmlFor="google_address">
                          {t(
                            "cart.ordering_method.delivery.form.google_address"
                          )}
                        </Label>
                        <div>
                          <Autocomplete
                            id="google_address"
                            value={values.google_address}
                            onChange={(e: any) => {
                              setFieldValue(
                                "google_address",
                                e.target.value,
                                true
                              );
                            }}
                            disabled={isLoading}
                            placeholder={t(
                              "cart.ordering_method.delivery.form.google_address_placeholder"
                            )}
                            apiKey={Config.env.app.google_map_key as string}
                            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                            onPlaceSelected={(place: any) => {
                              const addressComponents =
                                place?.address_components || [];
                              let postalCode = "";
                              let country = "";
                              let area = "";
                              addressComponents.forEach((component: any) => {
                                if (component.types.includes("locality")) {
                                  area = component.long_name; // or component.short_name if you prefer
                                }

                                if (component.types.includes("postal_code")) {
                                  postalCode = component.long_name; // or component.short_name if you prefer
                                }
                                if (component.types.includes("country")) {
                                  country = component.short_name; // or component.short_name if you prefer
                                }
                              });

                              setFieldValue(
                                "street_name",
                                place?.formatted_address
                              );
                              setFieldValue("area", area);
                              setFieldValue("postal_code", postalCode);

                              setFieldValue("location", {
                                lat: place?.geometry.location.lat(),
                                lng: place?.geometry.location.lng(),
                              });
                              setFieldValue(
                                "google_address",
                                place?.formatted_address,
                                true
                              );
                              setGoogleAddressPayload([
                                {
                                  location: {
                                    lat: place?.geometry.location.lat(),
                                    lng: place?.geometry.location.lng(),
                                  },
                                },
                                { google: place },
                              ]);
                            }}
                            options={{
                              componentRestrictions: {
                                country: ["AT", "CH", "DE", "LI"],
                              },
                              types: ["address"],
                              fields: ["ALL"],
                            }}
                          />
                          {errors.google_address && touched.google_address ? (
                            <FormError
                              msg={t(errors.google_address as string)}
                            />
                          ) : null}
                          {errors.location && touched.location ? (
                            <FormError msg={t(errors.location as string)} />
                          ) : null}
                        </div>
                      </div>
                      <div className="grid gap-2 w-full">
                        <Label className="text-left" htmlFor="postal_code">
                          {t("cart.ordering_method.delivery.form.postal_code")}
                        </Label>
                        <div>
                          <Input
                            type="number"
                            id="postal_code"
                            placeholder={t(
                              "cart.ordering_method.delivery.form.postal_code_placeholder"
                            )}
                            value={values.postal_code}
                            onChange={(e: any) => {
                              setFieldValue(
                                "postal_code",
                                e.target.value,
                                true
                              );
                            }}
                            disabled={true}
                          />
                          {errors.postal_code && touched.postal_code ? (
                            <FormError msg={t(errors.postal_code as string)} />
                          ) : null}
                        </div>
                      </div>
                      <div className="grid gap-2 w-full">
                        <Label className="text-left" htmlFor="block_building">
                          {t(
                            "cart.ordering_method.delivery.form.block_building"
                          )}
                        </Label>
                        <div>
                          <Input
                            id="block_building"
                            placeholder={t(
                              "cart.ordering_method.delivery.form.block_building_placeholder"
                            )}
                            value={values.block_building}
                            onChange={(e: any) => {
                              setFieldValue(
                                "block_building",
                                e.target.value,
                                true
                              );
                            }}
                            disabled={isLoading}
                          />
                          {errors.block_building && touched.block_building ? (
                            <FormError
                              msg={t(errors.block_building as string)}
                            />
                          ) : null}
                        </div>
                      </div>
                      <div className="grid gap-2 w-full">
                        <Label className="text-left" htmlFor="intercom">
                          {t("cart.ordering_method.delivery.form.intercom")}
                        </Label>
                        <div>
                          <Input
                            id="intercom"
                            placeholder={t(
                              "cart.ordering_method.delivery.form.intercom_placeholder"
                            )}
                            value={values.intercom}
                            onChange={(e: any) => {
                              setFieldValue("intercom", e.target.value, true);
                            }}
                            disabled={isLoading}
                          />
                          {errors.intercom && touched.intercom ? (
                            <FormError msg={t(errors.intercom as string)} />
                          ) : null}
                        </div>
                      </div>
                      <div className="grid gap-2 w-full">
                        <Label className="text-left" htmlFor="where_to_park">
                          {t(
                            "cart.ordering_method.delivery.form.where_to_park"
                          )}
                        </Label>
                        <div>
                          <Input
                            id="where_to_park"
                            placeholder={t(
                              "cart.ordering_method.delivery.form.where_to_park_placeholder"
                            )}
                            value={values.where_to_park}
                            onChange={(e: any) => {
                              setFieldValue(
                                "where_to_park",
                                e.target.value,
                                true
                              );
                            }}
                            disabled={isLoading}
                          />
                          {errors.where_to_park && touched.where_to_park ? (
                            <FormError
                              msg={t(errors.where_to_park as string)}
                            />
                          ) : null}
                        </div>
                      </div>
                      {/* <div className="grid gap-2 w-full">
                      <Label className="text-left" htmlFor="street_name">
                        {t("cart.ordering_method.delivery.form.street_name")}
                      </Label>
                      <div>
                        <Input
                          id="street_name"
                          placeholder={t(
                            "cart.ordering_method.delivery.form.street_name_placeholder"
                          )}
                          value={values.street_name}
                          onChange={(e: any) => {
                            setFieldValue("street_name", e.target.value, true);
                          }}
                          disabled={isLoading}
                        />
                        {errors.street_name && touched.street_name ? (
                          <FormError msg={t(errors.street_name as string)} />
                        ) : null}
                      </div>
                    </div>
                    <div className="grid gap-2 w-full">
                      <Label className="text-left" htmlFor="area">
                        {t("cart.ordering_method.delivery.form.area")}
                      </Label>
                      <div>
                        <Input
                          id="area"
                          placeholder={t(
                            "cart.ordering_method.delivery.form.area_placeholder"
                          )}
                          value={values.area}
                          onChange={(e: any) => {
                            setFieldValue("area", e.target.value, true);
                          }}
                          disabled={isLoading}
                        />
                        {errors.area && touched.area ? (
                          <FormError msg={t(errors.area as string)} />
                        ) : null}
                      </div>
                    </div>
                    <div className="grid gap-2 w-full">
                      <Label className="text-left" htmlFor="postal_code">
                        {t("cart.ordering_method.delivery.form.postal_code")}
                      </Label>
                      <div>
                        <Input
                          type="number"
                          id="postal_code"
                          placeholder={t(
                            "cart.ordering_method.delivery.form.postal_code_placeholder"
                          )}
                          value={values.postal_code}
                          onChange={(e: any) => {
                            setFieldValue("postal_code", e.target.value, true);
                          }}
                          disabled={isLoading}
                        />
                        {errors.postal_code && touched.postal_code ? (
                          <FormError msg={t(errors.postal_code as string)} />
                        ) : null}
                      </div>
                    </div>
                    */}
                    </div>
                  )}

                <div className="flex justify-between w-full">
                  {isAddNewAddress ||
                    (isEditAddress && (
                      <Button
                        type="button"
                        variant={"outline"}
                        onClick={() => {
                          setAddNewAddress(false), setEditAddress(false);
                        }}
                        disabled={isLoading}
                      >
                        {t("back")}
                      </Button>
                    ))}
                  <div className="flex justify-end w-full">
                    <Button disabled={isLoading} type="submit">
                      {isLoading && (
                        <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
                      )}
                      {t("save")}
                    </Button>
                  </div>
                </div>
              </AccordionContent>
            </form>
          );
        }}
      </Formik>
    </AccordionItem>
  );
}
